class VideoYearbook {
    constructor(element) {
        Object.defineProperty(this, "element", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.element = element;
        this.element.addEventListener('click', this.playVideo.bind(this));
    }
    playVideo() {
        jwplayer('player').setup({
            playlist: this.playlist,
            mute: false,
            repeat: false,
        });
        this.showLightbox();
    }
    get playlist() {
        const url = this.element.dataset.video ?? '';
        if (url.includes('.m3u8')) {
            return [
                {
                    file: url,
                    title: '',
                },
            ];
        }
        else if (url.includes('.json')) {
            return url;
        }
        return;
    }
    showLightbox() {
        const lightboxWrapper = document.querySelector('.block-video__lightbox-wrapper');
        lightboxWrapper?.classList.add('active');
    }
}
export default function yearbookVideo() {
    const videos = document.querySelectorAll('.block-video-yearbook__entry');
    for (const element of videos) {
        new VideoYearbook(element);
    }
}
